import * as React from 'react'

import * as SeparatorPrimitive from '@radix-ui/react-separator'
import { cn } from '@utils/style-utils'

export const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>
>(({ className, orientation = 'horizontal', decorative = true, ...props }, ref) => (
  <SeparatorPrimitive.Root
    ref={ref}
    decorative={decorative}
    orientation={orientation}
    className={cn(
      'twp shrink-0 bg-grey-lighter',
      orientation === 'horizontal' ? 'h-px w-full' : 'w-px self-stretch',
      className
    )}
    {...props}
  />
))
Separator.displayName = SeparatorPrimitive.Root.displayName
